import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import WorkerPage from './pages/WorkerPage';
import DashboardPage from './pages/DashboardPage';
import JobDetailPage from './pages/JobDetailPage';
import DeletedJobsPage from './pages/DeletedJobsPage';
import UsersPage from './pages/UsersPage';
import QRSheetPage from './pages/QRSheetPage';
import FloorPage from './pages/FloorPage';
import TerminalPage from './pages/TerminalPage';
import TimesheetPage from './pages/TimesheetPage';
import './App.css';

function RequireAuth({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading-screen">Loading…</div>;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'worker') return <Navigate to="/work" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/work" element={
            <RequireAuth roles={['worker','manager','admin']}>
              <WorkerPage />
            </RequireAuth>
          } />
          <Route path="/dashboard" element={
            <RequireAuth roles={['manager','admin']}>
              <DashboardPage />
            </RequireAuth>
          } />
          <Route path="/users" element={
            <RequireAuth roles={['manager','admin']}>
              <UsersPage />
            </RequireAuth>
          } />
          <Route path="/jobs/deleted" element={
            <RequireAuth roles={['manager','admin']}>
              <DeletedJobsPage />
            </RequireAuth>
          } />
          <Route path="/jobs/:id/qr-sheet" element={
            <RequireAuth roles={['manager','admin']}>
              <QRSheetPage />
            </RequireAuth>
          } />
          <Route path="/terminal" element={<TerminalPage />} />
          <Route path="/timesheet" element={
            <RequireAuth roles={['worker','manager','admin']}>
              <TimesheetPage />
            </RequireAuth>
          } />
          <Route path="/floor" element={
            <RequireAuth roles={['manager','admin']}>
              <FloorPage />
            </RequireAuth>
          } />
          <Route path="/jobs/:id" element={
            <RequireAuth roles={['manager','admin']}>
              <JobDetailPage />
            </RequireAuth>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
